import { Product } from '@acorn-portal/shared/src/services/interface/Shared';

export const isProduct = (x: string): x is Product => {
	return Object.values(Product).includes(x as Product) !== undefined;
};
